import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/login'
import Home from '@/views/home'
import Data from '@/views/data'
import Account from '@/views/account'
Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
    {
      path:'/',
      redirect:'/login'
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/home',
      component: Home,
      children:[
        {
          path: '/data',
          name: 'data',
          component: Data,
        },
        {
          path: '/account',
          name: 'account',
          component: Account,
        },
      ]
    }
  ]
})


const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js